import { render, staticRenderFns } from "./StepConfigSummary.vue?vue&type=template&id=aefabb70&scoped=true"
import script from "./StepConfigSummary.vue?vue&type=script&lang=js"
export * from "./StepConfigSummary.vue?vue&type=script&lang=js"
import style0 from "./StepConfigSummary.vue?vue&type=style&index=0&id=aefabb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefabb70",
  null
  
)

export default component.exports